export type NewsCategory = "行业新闻" | "影评" | "活动报道";

export interface NewsItem {
  id: string;
  title: string;
  category: NewsCategory;
  publishDate: string;
  summary: string;
  author: string;
  cover: string;
  content: string[];
}

export const newsCategories: NewsCategory[] = ["行业新闻", "影评", "活动报道"];

export const newsList: NewsItem[] = [
  {
    id: "forum-2026-shortfilm",
    title: "2026 影视短片创作论坛落幕：短片正在成为行业的新入口",
    category: "行业新闻",
    publishDate: "2026-10-16",
    summary:
      "为期两天的影视短片创作论坛在城西创意园结束，来自制作、发行与平台的三百多位从业者围绕短片工业化、版权与出海展开讨论。",
    author: "编辑部 · 陆沉",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20modern%20creative%20industry%20conference%20stage%20with%20warm%20lighting%2C%20audience%20silhouettes%2C%20large%20screen%20showing%20abstract%20film%20imagery%2C%20professional%20atmosphere%2C%20muted%20warm%20tones%2C%20cinematic%20depth&width=800&height=450&seq=news-forum-01&orientation=landscape",
    content: [
      "为期两天的 2026 影视短片创作论坛昨天在城西创意园落幕。与往年不同，今年的议题从「怎么拍」转向了「怎么被看见」：短片如何进入院线前的窗口期、如何与长片项目形成人才通道、以及短片版权在海外市场的实际收益模型，成为讨论最密集的三个方向。",
      "开幕式上，论坛发布了今年的短片创作观察报告。报告显示，过去一年国内公开渠道可检索的原创短片数量同比增长约三成，其中十分钟以内的作品占比接近一半；与此同时，能够完成完整发行链路（节展、平台、版权销售）的作品仍然是少数。",
      "「短片不是长片的练习册。」一位与会导演在主旨发言中说，「它有自己的节奏、自己的观众，也有自己的商业逻辑。我们最缺的不是拍摄能力，而是让作品被完整对待的机制。」这句话在现场被反复引用。",
      "论坛最后一场圆桌围绕青年创作者扶持展开。多位制片人提到，未来会更看重创作者在短片阶段呈现出的「完整表达能力」——不是预算规模，而是能否在有限时长里把一个想法讲清楚。下一届论坛将于明年秋季举行。",
    ],
  },
  {
    id: "guitou-award",
    title: "《归途》摘得亚洲短片节最佳剧情片：十八小时的车程讲了什么",
    category: "行业新闻",
    publishDate: "2026-10-15",
    summary:
      "林致远执导的《归途》在亚洲短片节拿下最佳剧情片，评委会称其「用极简的空间完成了复杂的情感调度」。",
    author: "行业组 · 沈望",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20photograph%20of%20a%20film%20award%20trophy%20on%20a%20dark%20stage%20with%20warm%20golden%20spotlight%2C%20blurred%20audience%20in%20background%2C%20elegant%20minimal%20composition%2C%20shallow%20depth%20of%20field%2C%20moody%20tones&width=800&height=450&seq=news-award-02&orientation=landscape",
    content: [
      "亚洲短片节昨日公布竞赛单元结果，林致远的《归途》获得最佳剧情片。这部十二分钟的短片几乎全部发生在一辆夜班大巴里，三位乘客、一段夜路，构成了全片的所有场景。",
      "评委会在颁奖词中写道：「影片用极简的空间完成了复杂的情感调度。导演没有解释任何人的过去，却让观众在沉默里自行补全。」评审团主席在映后交流中提到，这是今年竞赛单元里「最克制也最完整」的一部作品。",
      "林致远在领奖时表示，片子的雏形来自他一次真实的夜班长途经历。「那天车上只有四个人，没有人说话，但我能感觉到每个人都在心里算着一件事。我后来想，也许回家这件事本身就是不需要台词的。」",
      "据悉，《归途》将在下月开启国内巡展，计划在八个城市进行限定放映，并配套一场创作分享。制片方同时透露，长片版本的剧本已在开发中，但不会直接扩写短片内容。",
    ],
  },
  {
    id: "vertical-short-drama",
    title: "竖屏短片进入「叙事升级」阶段，平台开始重新计算完播率",
    category: "行业新闻",
    publishDate: "2026-10-13",
    summary:
      "多家内容平台调整竖屏短片的推荐逻辑，从单纯追逐前三秒留存，转向对完整叙事结构的加权。",
    author: "行业组 · 陈默",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20image%20of%20a%20smartphone%20screen%20glowing%20in%20a%20dark%20room%2C%20horizontal%20light%20stripes%2C%20data%20visualization%20lines%20in%20warm%20orange%2C%20minimal%20modern%20tech%20aesthetic%2C%20shallow%20focus&width=800&height=450&seq=news-vertical-03&orientation=landscape",
    content: [
      "过去两年，竖屏短片的内容逻辑几乎被「前三秒」这三个字统治。但最近一段时间，几家平台的产品负责人在不同场合提到了同一个变化：单纯依靠强钩子的内容，留存曲线正在变得不可预测。",
      "一位平台内容负责人解释，这并不意味着钩子失效，而是观众开始对「钩子之后什么都没有」产生疲劳。「当所有人都在前三秒放大招，前三秒就不再稀缺。稀缺的是第二十秒、第四十秒还能不能留住人。」",
      "与之对应，推荐算法开始引入「完整叙事结构」的加权指标：转折是否自然、结尾是否收束、复看率是否高于平均值。一些以叙事见长的创作团队因此获得了更稳定的流量。",
      "对创作者来说，这意味着竖屏短片正在从「片段」回到「作品」。有导演在采访中表示，这可能是竖屏内容第一次真正需要编剧。",
    ],
  },
  {
    id: "zhiyuan-behind",
    title: "《纸鸢》幕后：五分钟的无对白动画，画了十一个月",
    category: "活动报道",
    publishDate: "2026-10-11",
    summary:
      "在动画短片《纸鸢》的放映分享会上，导演苏念展示了三百多张废弃的分镜稿，以及一段从未公开的测试片段。",
    author: "活动组 · 苏木",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20photo%20of%20an%20animation%20studio%20desk%20covered%20with%20hand%20drawn%20storyboard%20sketches%2C%20colored%20pencils%2C%20a%20light%20table%2C%20soft%20window%20light%2C%20cozy%20creative%20workspace%2C%20shallow%20depth%20of%20field&width=800&height=450&seq=news-zhiyuan-04&orientation=landscape",
    content: [
      "周日下午的放映厅里坐满了人，大多数是学动画的学生。《纸鸢》正片只有五分钟，没有一句对白，放映结束后掌声持续了近二十秒。",
      "导演苏念带来的分享材料比片子本身长得多：三百多张废弃分镜、两版完全不同的角色设定，以及一段从未公开的测试片段。「最早这版是有台词的，爷爷会说很多话。」她说，「后来我们发现，只要他一开口，观众就不再看他的手了。」",
      "全片最重要的一个镜头——线在手里绷紧、又缓缓松开——单独制作了六周。团队用二维手绘叠加纸张纹理，为了表现「线」的重量，甚至用真实的棉线做了一段逐帧参考。",
      "在被问到为什么坚持手绘时，苏念的回答很直接：「因为我想让观众看见笔触。有些情绪是算法画不出来的，比如犹豫。」《纸鸢》目前已确认入围三个国际短片节。",
    ],
  },
  {
    id: "review-12-minutes",
    title: "影评：短片如何用十二分钟讲完一生",
    category: "影评",
    publishDate: "2026-10-10",
    summary:
      "从《归途》到《老照相馆》，今年的短片创作正在证明：时长的限制从来不是叙事的敌人，而是它的语法。",
    author: "特约影评人 · 顾南",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20still%20of%20an%20empty%20movie%20theater%20with%20a%20single%20lit%20screen%2C%20red%20velvet%20seats%2C%20dust%20in%20projector%20beam%2C%20deep%20shadows%2C%20contemplative%20atmosphere%2C%20film%20grain&width=800&height=450&seq=news-review-05&orientation=landscape",
    content: [
      "十二分钟能讲什么？如果按常规剧作的节奏，大概只够完成一次相遇和一次告别。但今年的几部短片给出了不同的答案：它们不讲述完整的时间，而是截取一段时间，让观众自己去补全前后的空白。",
      "《归途》选择的是十八个小时的车程，实际呈现却只有十二分钟。导演把大量的时间留给了沉默：售票窗口的找零、行李架上的塑料袋、窗外一闪而过的加油站。这些看似无关的细节，构成了人物全部的过去。",
      "《老照相馆》走的是另一条路。它用三天里三十七位陌生人的快门声，拼出一个街区四十年的历史。片中没有一个完整的人物弧光，但当最后一面照片墙出现时，观众已经替所有人完成了告别。",
      "短片的优势不在于短，而在于它敢于省略。长片需要交代，短片可以只呈现结果——而结果往往比过程更有力量。这或许就是为什么，今年最动人的几段影像，都发生在二十分钟以内。",
    ],
  },
  {
    id: "youth-director-plan",
    title: "青年导演扶持计划开放报名，今年新增纪录片单元",
    category: "行业新闻",
    publishDate: "2026-10-08",
    summary:
      "新一季青年导演扶持计划启动，将通过短片提案、工作坊与成片辅导三个阶段支持二十个项目。",
    author: "行业组 · 沈望",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20young%20filmmakers%20in%20a%20workshop%20discussion%20around%20a%20table%20with%20storyboards%20and%20laptops%2C%20bright%20studio%20space%2C%20natural%20daylight%2C%20collaborative%20atmosphere%2C%20documentary%20style&width=800&height=450&seq=news-youth-06&orientation=landscape",
    content: [
      "青年导演扶持计划今日开放新一季报名，报名截止时间为十一月底。据介绍，本季计划将支持二十个短片项目，覆盖剧情、动画、实验与纪录片四个方向，其中纪录片单元为今年新增。",
      "与往年不同，本季在流程上增加了「成片辅导」环节。入选项目在完成粗剪后，可获得一次与剪辑指导、混音师的一对一工作坊，帮助作品在节展投递前完成最后打磨。",
      "主办方表示，新增纪录片单元源于过去两年的报名数据：纪录片提案数量增长明显，但能够获得制作支持的渠道相对有限。「我们不想让好的观察因为预算问题停在素材阶段。」",
      "报名不设年龄与学历限制，需提交一份不超过五页的提案与过往作品片段。结果将于十二月中旬公布，入选项目将在明年春季进入制作。",
    ],
  },
  {
    id: "october-playlist",
    title: "十月片单：值得花二十分钟看完的十部短片",
    category: "影评",
    publishDate: "2026-10-05",
    summary:
      "从末日科幻到胡同纪录片，这份片单按情绪而非类型排列，适合在一个安静的晚上连续看完。",
    author: "编辑部 · 顾南",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20lay%20editorial%20photograph%20of%20film%20stills%20arranged%20on%20a%20warm%20neutral%20surface%20with%20a%20notebook%2C%20coffee%20cup%20and%20pen%2C%20soft%20natural%20light%2C%20minimal%20aesthetic%2C%20muted%20earth%20tones&width=800&height=450&seq=news-playlist-07&orientation=landscape",
    content: [
      "这个月的片单我们不按类型分，而是按情绪。如果你今晚想被安静地击中，可以从《无声的合唱》开始；如果你想笑一下再沉默很久，那就先看《今天不加班》。",
      "第一组是「关于离开」：《归途》《纸鸢》《深海来信》。三部片子都在讲告别，但方式完全不同——一个在车上，一个在天上，一个在海底。连起来看会发现，告别这件事的形状，其实取决于留下的人站在哪里。",
      "第二组是「关于留下」：《城市之光》《山那边的课堂》《老照相馆》。它们都发生在具体的空间里，都有一群不被镜头偏爱太久的普通人。看完之后你可能会想在自己住的那条街上多走两圈。",
      "最后一组留给想象：《逆光飞行》《第七次日出》《星尘咖啡馆》。三部都在处理时间，一部向外（世界要结束了），两部向内（记忆和愿望）。建议放在深夜观看，效果最好。",
    ],
  },
  {
    id: "documentary-revival",
    title: "纪录片短片的「小复兴」：观众开始想看真实的人",
    category: "影评",
    publishDate: "2026-09-30",
    summary:
      "过去一年，纪录片短片在多个平台的播放完成率显著高于平均值，创作者与观众的关系正在被重新定义。",
    author: "特约影评人 · 叶知秋",
    cover:
      "https://readdy.ai/api/search-image?query=Documentary%20photography%20of%20a%20small%20town%20street%20at%20golden%20hour%2C%20local%20residents%20going%20about%20daily%20life%2C%20warm%20dusty%20light%2C%20authentic%20candid%20moment%2C%20shallow%20depth%20of%20field%2C%20film%20grain&width=800&height=450&seq=news-doc-08&orientation=landscape",
    content: [
      "如果只看播放量，纪录片短片从来不是最亮眼的那一类。但如果看完成率，情况就反过来了：多个平台的数据显示，十分钟以上的纪录片短片，平均完播率高于同长度的剧情短片。",
      "原因或许不复杂。当虚构内容越来越依赖强设定和快节奏，真实的、未经编排的生活反而提供了另一种稀缺：不解释，不煽情，只是让你看。",
      "《山那边的课堂》是一个典型例子。全片几乎没有配乐，最长的一个镜头是老师擦黑板，擦了将近四十秒。有观众在评论区写：「我很久没有耐心看完一件事了，但这段我看了三遍。」",
      "当然，纪录片的门槛并没有降低。它要求创作者真正待在一个地方，等到事情发生。这种「等待」的成本，在追求效率的行业里显得有些笨拙，但也正是这种笨拙，让画面有了重量。",
    ],
  },
  {
    id: "city-image-week",
    title: "城市影像周开幕：三十部短片在七个空间同步放映",
    category: "活动报道",
    publishDate: "2026-09-26",
    summary:
      "为期九天的城市影像周昨日开幕，短片放映分布在书店、咖啡馆与老厂房等七个非传统空间。",
    author: "活动组 · 苏木",
    cover:
      "https://readdy.ai/api/search-image?query=Evening%20photo%20of%20an%20outdoor%20short%20film%20screening%20in%20a%20renovated%20industrial%20courtyard%2C%20projector%20beam%2C%20people%20sitting%20on%20wooden%20benches%2C%20string%20lights%2C%20warm%20intimate%20atmosphere%2C%20documentary%20style&width=800&height=450&seq=news-cityweek-09&orientation=landscape",
    content: [
      "城市影像周昨晚在一处改造过的老厂房开幕。与常规影展不同，今年的三十部短片分布在七个非传统空间放映：两家书店、三家咖啡馆、一座老厂房和一间社区活动室。",
      "策展人介绍，这样的安排是想让「看电影」重新变成一件发生在生活里的事。「在影院里，你买票、关灯、安静两小时。但在书店的下午，你可能是买咖啡的时候顺手坐下，然后看完了一部二十分钟的纪录片。」",
      "开幕片是《城市之光》，放映结束后，片中的一位环卫工来到现场。他说自己从来没看过自己工作的样子，「原来凌晨的街是这个颜色的」。这句话让现场安静了很久。",
      "影像周将持续九天，所有场次免费，需提前预约。主办方表示，明年计划把放映空间扩展到更多的社区，并增加一场面向中学生的工作坊。",
    ],
  },
  {
    id: "ai-in-shortfilm",
    title: "当 AI 进入短片制作流程：效率提升了，作者还在吗",
    category: "行业新闻",
    publishDate: "2026-09-22",
    summary:
      "从分镜预演到后期修复，AI 工具正在渗透短片制作的多个环节，也带来了关于作者性与行业分工的新讨论。",
    author: "行业组 · 陈默",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20visual%20of%20a%20film%20editing%20suite%20with%20multiple%20monitors%20showing%20storyboards%20and%20timelines%2C%20cool%20ambient%20light%2C%20warm%20desk%20lamp%2C%20creative%20studio%20atmosphere%2C%20shallow%20depth%20of%20field&width=800&height=450&seq=news-ai-10&orientation=landscape",
    content: [
      "在一部十五分钟的科幻短片里，AI 承担了三个环节：分镜预演、部分环境素材的生成、以及后期画面的降噪修复。制片人算了一笔账，这三项工作节省了大约六周的前期周期。",
      "类似的流程正在变得普遍。多位接受采访的从业者表示，AI 在短片阶段的价值主要体现在「让试错变便宜」——导演可以在开拍前看到十种不同的镜头方案，而不必真的搭景。",
      "但作者性的问题也随之而来。一位摄影师提到，他最近推掉了一个项目，因为对方希望「全部画面都用生成的方式完成」。「那不是拍电影，那是选图。」他说。",
      "行业里较为一致的观点是：工具会继续普及，但决定作品好坏的仍然是对人的理解。「AI 可以帮你拍出一百个漂亮的镜头，但它不知道哪一个应该被剪掉。」一位剪辑师说。",
    ],
  },
];